import { PageHeader } from '@/components/shared/page-header';
import { PasswordForm, ProfileForm, SessionsSection } from '@/features/settings/account-page';
import { Section } from '@/features/settings/section';

/** Fuso fixo: o operador não pertence a nenhuma barbearia, então não há fuso de organização. */
const PLATFORM_TZ = 'America/Sao_Paulo';

/** "Minha conta" do operador: nome, e-mail, senha e sessões. Nada que dependa de barbearia. */
export function PlatformAccountPage() {
  return (
    <div className="grid max-w-3xl gap-10">
      <PageHeader
        title="Minha conta"
        description="Seus dados de acesso à administração da plataforma."
        actions={<span className="rounded-full bg-brass/15 px-2.5 py-0.5 text-xs font-medium text-amber-ink">Super admin</span>}
      />
      <ProfileForm />
      <Section title="Senha" description="Ao trocar a senha, os outros aparelhos são desconectados.">
        <PasswordForm />
      </Section>
      <SessionsSection tz={PLATFORM_TZ} />
    </div>
  );
}
